<template>
  <div class="classify">
    <Tree ref="treeDom" :data="classify_data" show-checkbox></Tree>
  </div>
</template>

<script>
export default {
  name: "Classify",
  props: {
    dataUrl: {
      type: String
    },
    title: {
      type: String,
      default: 'name'
    },
    checks: {
      type: Array
    }
  },
  data() {
    return {
      classify_data: []
    };
  },
  async created() {
    await this.getList();
  },
  watch: {
    checks: {
      deep: true,
      handler: function() {
        this.getList();
      }
    }
  },
  methods: {
    async getList() {
      let classify_data = await this.$http.get(this.dataUrl);
      this.InitList(classify_data);
    },
    // includes数组检测值
    InitList(list) {
      let new_list = list;
      let title = this.title;
      let checks = this.checkList();
      new_list.forEach(item => {
        if (checks.length && checks.includes(item.id)) {
          item.checked = true;
        }
        if (title) item.title = item[title];
        if (item.child) item.children = item.child;
        if (item.children) {
          item.children.forEach(it => {
            if (checks.length && checks.includes(it.id)) {
              it.checked = true;
            }
            if (title) it.title = it[title];
          });
        }
      });
      this.classify_data = new_list;
    },
    checkList() {
      let checks = [];
      if (this.checks) {
        this.checks.forEach(item => {
          checks.push(item.id);
        });
      }
      return checks;
    },
    getSelectList() {
      return this.$refs.treeDom.getCheckedNodes();
    }
  }
};
</script>

<style scoped>
</style>
